/**
 * Default Agent Config — shared demo config for auto-created agent files.
 *
 * Used by:
 *  - ensureHomeWorkspace() in useWorkspace.tsx (Home workspace scaffolding)
 *  - ensureAgentConfig() in AgentPicker.tsx (on-demand agent creation when user triggers AI)
 *
 * The sample leaves provider auth empty on purpose so users can fill it in.
 */

export const DEFAULT_AGENT_CONFIG = {
    v: '1',
    type: 'chat-agent',
    name: 'SecureBlob Assistant',
    provider: {
        type: 'openai-chat-completions',
        apiKey: '',
        baseUrl: 'https://home.hoglundit.se/v1',
        apiMode: 'chat-completions',
    },
    model: '',
    systemPrompt:
        'You are a helpful assistant for the SecureBlob workspace. You can read and write files. Keep answers concise and helpful. Today\'s date is {{ date }}. When citing search results or web pages, include normal references/links in your answer.',
    limits: { softSpendUsd: '2.00' },
    tools: { secureBlob: { read: true, write: true } },
    mcp: {
        exa: {
            url: 'https://mcp.exa.ai/mcp',
            enabled: true,
            proxy: true,
        },
    },
} as const

/** Serialized JSON for writing to workspace files */
export const DEFAULT_AGENT_CONFIG_JSON = JSON.stringify(DEFAULT_AGENT_CONFIG, null, 2)
